export default __webpack_public_path__ + "static/media/image-cover.903933c3.png";